<template>
  <!-- http://www.cnblogs.com/ertingbo/p/8135391.html -->
  <el-container direction="vertical" id="main">
    <app-header :name="username"></app-header>
    <el-container>
      <app-menu :appRoles="appRoles" @getmenu="getmenu"></app-menu>
      <el-container >
        <el-main
          v-if="breadcrumbInfo.pName"
          v-loading="$store.state.doLoading"
          element-loading-text="等哈就好了"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-breadcrumb separator="/" v-show="breadcrumbInfo.pName">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>
              <i :class="breadcrumbInfo.pIcon">&nbsp&nbsp{{ breadcrumbInfo.pName }}</i>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <i :class="breadcrumbInfo.cIcon">&nbsp&nbsp{{breadcrumbInfo.cName}}</i>
            </el-breadcrumb-item>
          </el-breadcrumb>
          <div id="view">
            <router-view :roles="roles"></router-view>
            <!-- <div id="test"></div> -->
          </div>
        </el-main>
        <!-- <el-footer>Footer</el-footer> -->
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
  import Header from "@/components/mysys/Header";
  import Menu from "@/components/mysys/Menu";

  export default {
    components: {
      appHeader: Header,
      appMenu: Menu
    },
    data: function () {
      return {
        postApi: {
          crud: "",
          info: {}
        },
        isCollapse: true,
        username: "",
        appRoles: [
          {
            name: "未加载",
            url: "#",
            icon: "el-icon-document",
            children: [
              {name: "1", icon: "el-icon-menu", url: "sdfa"},
              {name: "2", icon: "el-icon-menu", url: "sdfa"},
              {name: "4", icon: "el-icon-setting", url: "sdfa"}
            ]
          },
          {
            name: "未加载",
            url: "asdfasd",
            icon: "el-icon-document"
          }
        ],
        breadcrumbInfo: {
          pIcon: "",
          pName: "",
          cIcon: "",
          cName: ""
        },
        roles: []
      };
    },
    beforeCreate: async function () {
      this.postApi = {
        crud: "r",
        info: {key: "web"}
      };
      let data = await this.$doPost("/api/index", this.postApi);
      if (data.msgCode === 0) {
        this.appRoles = data.result.infos.apps;
        this.username = data.result.infos.userName;
      }
    },
    methods: {
      getmenu: function (info) {
        this.breadcrumbInfo.pIcon = info.pIcon;
        this.breadcrumbInfo.pName = info.pName;
        this.breadcrumbInfo.cIcon = info.child.icon;
        this.breadcrumbInfo.cName = info.child.name;
        this.roles = info.child.roles.split(",");
        this.$router.push(info.child.url);
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #main {
    width: 100vw;
    height: 100vh;
  }

  .el-footer {
    background-color: #b3c0d1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-main {
    background-color: #e9eef3;
  }

  .el-breadcrumb,
  #view {
    background: #fff;
    padding: 20px 50px 20px 20px;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  #test {
    height: 300px;
    background-color: aqua;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue